<template>
  <div class="detail-box" :class="info.type ? 'back-color' : ''">
    <div class="main-content" v-if="!info.type">
      <div class="text">
        <div class="icon">
          <img src="../../assets/title-icon.png" alt="" />
        </div>
        <div class="text-box">
          <p class="title-big">{{ info.title }}</p>
          <p class="text-content">
            {{ info.content }}
          </p>
        </div>
      </div>
      <div class="img">
        <img :src="require('../../assets/' + info.img)" alt="" srcset="" />
      </div>
    </div>
    <div class="main-content" v-else>
      <div class="img">
        <img :src="imgUrl" alt="" /><img :src="require('../../assets/' + info.img)" alt="" srcset="" />
      </div>
      <div class="text">
        <div class="icon">
            <img src="../../assets/title-icon.png" alt="" />
        </div>
        <div class="text-box">
          <p class="title-big">{{ info.title }}</p>
          <p class="text-content">
            {{ info.content }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "detail",
  props: ["info"],
  data() {
    return {
      imgUrl: ""
    };
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.detail-box {
  width: 100%;
  height: 550px;
  .main-content {
    width: 1200px;
    height: 550px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .img{
      >img{
        width: 400px;
      }
    }
  }
  .text {
    height: 400px;
    display: flex;
    .icon {
      margin-right: 20px;
      margin-top: 56px;
    }
    .text-box {
      margin-top: 114px;
    }
    .title-big {
      font-size: 48px;
      font-family: SourceHanSansSC-Bold, SourceHanSansSC;
      font-weight: bold;
      color: #2b3033;
      line-height: 71px;
      margin-bottom: 24px;
    }
    .text-content {
      width: 500px;
      font-size: 16px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      color: #2b3033;
      line-height: 24px;
    }
  }
}
.back-color {
  background: #f9f9f9;
}
</style>
